import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import './AccordionVertical.scss'

const BootstrapAccordion = ({ data, title }) => {
  return (
    <section className="accordion-section my-3 my-md-5">
      <div className="container">
        <div className="row">
          <div className="text-center col">
            <div className="accordion-title pb-2">
              {title}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <Accordion defaultActiveKey="0">
              {data.map((card, index) => (
                <Accordion.Item eventKey={index.toString()} key={card.id}>
                  <Accordion.Header>{card.title}</Accordion.Header>
                  <Accordion.Body>
                    <ReactMarkdown className="markdown-format">
                      {card.summary}
                    </ReactMarkdown>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BootstrapAccordion;

BootstrapAccordion.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string
};